<div class="info-tile-container">
    <app-info-tile
        [infoName]="'Total Medications'"
        [infoValue]="medicationStats.totalMedications"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'Expired Medications'"
        [infoValue]="medicationStats.expiredMedications"
    >
    </app-info-tile>

    <app-info-tile [infoName]="'Active'" [infoValue]="medicationStats.active">
    </app-info-tile>

    <!-- <app-info-tile [infoName]="'Age (days)'" [infoValue]="medicationStats.age">
    </app-info-tile> -->
</div>
